import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
} from '@mui/material';
import classes from '../simulator.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import {
  CcfBox,
  CcfDatePickerIcon,
  CcfDivider,
  CcfTextField,
  CcfTypography,
  DividerOrientation,
  DividerVariant,
} from '@nice-ccf/ui-controls';
import { updateCurrentInteraction } from '../simulator.slice';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import Carousel from 'react-material-ui-carousel';
import { getApplicationLocale } from '@nice-ccf/ui-components';

/* eslint-disable-next-line */
export interface CurrentInteractionProps {
  interactionList: any;
}

/**
 * used to show contact history card in simulator
 * @param props - ContactHistoryCardProps
 * @example ` <ContactHistoryCard />`
 */
export function CurrentInteraction(props: CurrentInteractionProps) {
  const { interactionList } = props;
  const [interactionData, setInteractionData]: any = useState(interactionList);
  const dispatch = useDispatch();
  const locale = useSelector(getApplicationLocale);

  // /**
  //  * handleChange Event - used to expand and collapse of channels accordion
  //  * @param panel- 'contacthistory'
  //  * @param event - changeevent
  //  * @param newExpanded - boolean
  //  * @example - handleChange(panel)
  //  */
  // const handleChange = (id: any, event: any) => {
  //   const updatedItems = interactionData.map((item: any) => {
  //     if (item.id === id) {
  //       return { ...item, customerName: event };
  //     }
  //     return item; // Keep other objects unchanged34
  //   });
  //   setInteractionData(updatedItems);
  //   dispatch(updateCurrentInteraction(updatedItems));
  // };

  useEffect(() => {
    setInteractionData(interactionList);
  }, [interactionList]);

  /**
   * handleChange Event - used to expand and collapse of channels accordion
   * @param panel- 'contacthistory'
   * @param event - changeevent
   * @param newExpanded - boolean
   * @example - handleChange(panel)
   */
  const handleInputChange = (
    id: any | undefined,
    field: string,
    value: string
  ) => {
    const data = interactionData.map((x: any) => {
      if (id === x.id) {
        return {
          ...x,
          [field]: value,
        };
      } else {
        return {
          ...x,
        };
      }
    });
    setInteractionData(data);
    dispatch(updateCurrentInteraction(data));
  };
  /**
   * Used to display date picker icon
   * @example - DatePickerIcon()
   */
  const DatePickerIcon = () => {
    return (
      <CcfBox sx={{ display: 'flex' }}>
        <CcfDatePickerIcon />
      </CcfBox>
    );
  };

  return (
    <Grid
      style={{ height: 'inherit', overflow: 'scroll' }}
      className={classes.simulatorColumn}
    >
      <Paper elevation={3} className={classes.simulatorPaperWithFullheight}>
        <Card className={classes.heightInherit}>
          <CardHeader title={`Current Interaction`} />
          <CardContent
            // className={
            //   classes.simulatorHistoryContent + ' ' + classes.fixedHeight
            // }
            style={{ paddingBottom: '0px' }}
          >
            <CcfBox>
              <CcfBox className={classes.suggestionCard}>
                <CcfTextField
                  fullWidth
                  color="primary"
                  id="sm_currentInteraction_crmIcon"
                  style={{ marginBottom: '15px', marginTop: '5px' }}
                  className={classes.input}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ classes: { input: classes.p10 } }}
                  value={interactionData[0].crmIcon}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    handleInputChange(
                      interactionData[0].id,
                      'crmIcon',
                      event?.target.value
                    );
                    // const data = interactionData.map((x: any) => ({
                    //   ...x,
                    //   crmIcon: event?.target.value,
                    // }));
                    // setInteractionData(data);
                    // dispatch(updateCurrentInteraction(data));
                  }}
                  label={'CRM Icon'}
                  variant="outlined"
                ></CcfTextField>
                <CcfTextField
                  fullWidth
                  color="primary"
                  id="sm_currentInteraction_crmUrl"
                  style={{ marginBottom: '15px' }}
                  className={classes.input}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ classes: { input: classes.p10 } }}
                  value={interactionData[0].crmUrl}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    handleInputChange(
                      interactionData[0].id,
                      'crmUrl',
                      event?.target.value
                    );
                    // const data = interactionData.map((x: any) => ({
                    //   ...x,
                    //   crmUrl: event?.target.value,
                    // }));
                    // setInteractionData(data);
                    // dispatch(updateCurrentInteraction(data));
                  }}
                  label={'CRM URL'}
                  variant="outlined"
                ></CcfTextField>

                <div>
                  <LocalizationProvider
                    adapterLocale={locale}
                    dateAdapter={AdapterDayjs}
                    id="sm_currentInteraction_date"
                  >
                    <DateTimePicker
                      label="Date"
                      value={dayjs(interactionData[0].date)}
                      onChange={(newValue: any) =>
                        handleInputChange(
                          interactionData[0].id,
                          'date',
                          new Date(newValue).toISOString()
                        )
                      }
                      renderInput={(props: any) => (
                        <CcfTextField
                          fullWidth
                          variant="outlined"
                          color="primary"
                          style={{ marginBottom: '15px' }}
                          className={classes.input}
                          InputProps={{
                            classes: { input: classes.p10 },
                          }}
                          id="date"
                          InputLabelProps={{ shrink: true }}
                          {...props}
                        />
                      )}
                      components={{
                        OpenPickerIcon: DatePickerIcon,
                      }}
                    />
                  </LocalizationProvider>
                </div>
                <CcfTextField
                  fullWidth
                  color="primary"
                  id={`sm_currentInteraction_label_${interactionData[0].label}`}
                  style={{ marginBottom: '15px' }}
                  className={classes.input}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ classes: { input: classes.p10 } }}
                  value={interactionData[0].label}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    handleInputChange(
                      interactionData[0].id,
                      'label',
                      event?.target.value
                    )
                  }
                  label={'Id'}
                  variant="outlined"
                ></CcfTextField>
                <CcfTextField
                  fullWidth
                  color="primary"
                  id={`sm_currentInteraction_status_${interactionData[0].status}`}
                  style={{ marginBottom: '15px' }}
                  className={classes.input}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ classes: { input: classes.p10 } }}
                  value={interactionData[0].status}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    handleInputChange(
                      interactionData[0].id,
                      'status',
                      event?.target.value
                    )
                  }
                  label={'Priority'}
                  variant="outlined"
                ></CcfTextField>
                <CcfTextField
                  fullWidth
                  color="primary"
                  id={`sm_currentInteraction_details_${interactionData[0].details}`}
                  style={{ marginBottom: '15px' }}
                  className={classes.input}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ classes: { input: classes.p10 } }}
                  value={interactionData[0].details}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    handleInputChange(
                      interactionData[0].id,
                      'details',
                      event?.target.value
                    )
                  }
                  label={'Details'}
                  variant="outlined"
                ></CcfTextField>
              </CcfBox>
            </CcfBox>
            <CcfDivider
              orientation={DividerOrientation.HORIZONTAL}
              variant={DividerVariant.FULLWIDTH}
              sx={{
                width: '100%',
                borderColor: '#D2D8DB',
                margin: '10px 0px',
              }}
            />
            <CcfBox
              style={{
                height: '285px',
              }}
            >
              <CcfBox style={{ paddingBottom: '10px' }}>
                <CcfTypography>Related Interactions</CcfTypography>
              </CcfBox>
              <Carousel
                autoPlay={false}
                indicators={true}
                animation="slide"
                navButtonsAlwaysVisible={false}
                className={classes.carousel}
                fullHeightHover={true}
                navButtonsProps={{
                  style: {
                    display: 'none',
                  },
                }}
                navButtonsWrapperProps={{
                  style: {
                    display: 'none',
                  },
                }}
              >
                {interactionData.slice(1).map((x: any, index: any) => (
                  <CcfBox key={index}>
                    <CcfTextField
                      fullWidth
                      color="primary"
                      id="sm_relatedInteraction_crmIcon"
                      style={{ marginBottom: '15px', marginTop: '5px' }}
                      className={classes.input}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{ classes: { input: classes.p10 } }}
                      value={x.crmIcon}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        const updatedData = [...interactionData];
                        updatedData[index + 1] = {
                          ...updatedData[index + 1],
                          crmIcon: event?.target.value,
                        };

                        setInteractionData(updatedData);
                        dispatch(updateCurrentInteraction(updatedData));
                      }}
                      label={'CRM Icon'}
                      variant="outlined"
                    ></CcfTextField>
                    <CcfTextField
                      fullWidth
                      color="primary"
                      id="sm_relatedInteraction_crmUrl"
                      style={{ marginBottom: '15px' }}
                      className={classes.input}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{ classes: { input: classes.p10 } }}
                      value={x.crmUrl}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        const updatedData = [...interactionData];
                        updatedData[index + 1] = {
                          ...updatedData[index + 1],
                          crmUrl: event?.target.value,
                        };

                        setInteractionData(updatedData);
                        dispatch(updateCurrentInteraction(updatedData));
                      }}
                      label={'CRM URL'}
                      variant="outlined"
                    ></CcfTextField>

                    <div>
                      <LocalizationProvider
                        adapterLocale={locale}
                        dateAdapter={AdapterDayjs}
                        id="sm_relatedInteraction_date"
                      >
                        <DateTimePicker
                          label="Date"
                          value={dayjs(x.date)}
                          onChange={(newValue: any) => {
                            const updatedData = [...interactionData];
                            updatedData[index + 1] = {
                              ...updatedData[index + 1],
                              date: new Date(newValue).toISOString(),
                            };
                            setInteractionData(updatedData);
                            dispatch(updateCurrentInteraction(updatedData));
                          }}
                          renderInput={(props: any) => (
                            <CcfTextField
                              fullWidth
                              variant="outlined"
                              color="primary"
                              style={{ marginBottom: '15px' }}
                              className={classes.input}
                              InputProps={{
                                classes: { input: classes.p10 },
                              }}
                              id="date"
                              InputLabelProps={{ shrink: true }}
                              {...props}
                            />
                          )}
                          components={{
                            OpenPickerIcon: DatePickerIcon,
                          }}
                        />
                      </LocalizationProvider>
                    </div>
                    <CcfTextField
                      fullWidth
                      color="primary"
                      id={`sm_relatedInteraction_label_${x.label}`}
                      style={{ marginBottom: '15px' }}
                      className={classes.input}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{ classes: { input: classes.p10 } }}
                      value={x.label}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        const updatedData = [...interactionData];
                        updatedData[index + 1] = {
                          ...updatedData[index + 1],
                          label: event?.target.value,
                        };
                        setInteractionData(updatedData);
                        dispatch(updateCurrentInteraction(updatedData));
                      }}
                      label={'Id'}
                      variant="outlined"
                    ></CcfTextField>
                    <CcfTextField
                      fullWidth
                      color="primary"
                      id={`sm_relatedInteraction_status_${x.status}`}
                      style={{ marginBottom: '15px' }}
                      className={classes.input}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{ classes: { input: classes.p10 } }}
                      value={x.status}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        const updatedData = [...interactionData];
                        updatedData[index + 1] = {
                          ...updatedData[index + 1],
                          status: event?.target.value,
                        };
                        setInteractionData(updatedData);
                        dispatch(updateCurrentInteraction(updatedData));
                      }}
                      label={'Status'}
                      variant="outlined"
                    ></CcfTextField>
                    <CcfTextField
                      fullWidth
                      color="primary"
                      id={`sm_relatedInteraction_details_${x.details}`}
                      style={{ marginBottom: '15px' }}
                      className={classes.input}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{ classes: { input: classes.p10 } }}
                      value={x.details}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        event.stopPropagation();
                        const updatedData = [...interactionData];
                        updatedData[index + 1] = {
                          ...updatedData[index + 1],
                          details: event?.target.value,
                        };
                        setInteractionData(updatedData);
                        dispatch(updateCurrentInteraction(updatedData));
                      }}
                      label={'Details'}
                      variant="outlined"
                    ></CcfTextField>
                  </CcfBox>
                ))}
              </Carousel>
            </CcfBox>
          </CardContent>
        </Card>
      </Paper>
    </Grid>
  );
}

export default CurrentInteraction;
